import { useCallback, useEffect } from 'react';
import { useMapEvents } from 'react-leaflet';
export function SetLocationComponent(props) {
    const { setLocation } = props;
    const onClickMap = useCallback((ev) => setLocation([ev.latlng.lng, ev.latlng.lat]), [setLocation]);
    const map = useMapEvents({
        click: onClickMap,
    });
    useEffect(() => {
        map.setView([56.3, 55], 3);
    }, []);
    return null;
}
